
<template>
  <div class="Intro">
    <div class="title">
      <div class="BigTitle">{{ $t("Eco.ecoTitle") }}</div>
      <div class="SubTitle">{{ $t("Eco.ecoWhat") }}</div>
      <div class="detail">{{ $t("Eco.ecoDetail") }}</div>
    </div>
    <div class="box-card">
       <div class="item">
        <!-- <img src="../../../assets/m/intro/Trustor.png"/> -->
        <div class="introT">{{ $t("Eco.Conditions") }}</div>
        <div class="introD">{{ $t("Eco.ConditionsDetail") }}</div>
      </div>
      <div class="item">
        <img src="../../../assets/m/intro/Trustor.png"/>
        <div class="introT">{{ $t("Eco.rewards") }}</div>
        <div class="introD">{{ $t("Eco.rewardDetails") }}</div>
      </div>
      <div class="item">
        <img src="../../../assets/m/intro/Trustor-rule.png"/>
        <div class="introT">{{ $t("Eco.rule") }}</div>
        <div class="introD">{{ $t("Eco.ruleDetail") }}</div>
      </div>
      <div class="item">
        <div class="tips"> {{ $t("Eco.tip") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
div {
  box-sizing: border-box;
}
.clearfix:after{
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;
}
.clearfix{
    *zoom: 1;
}
.Intro {
  text-align: center;
  margin-bottom: 157px;
  width: 100%;
  color: #000000;
  .title {
    text-align: center;
    /*height: 761px;*/
    background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
    100%;
    .BigTitle {
      padding-top: 230px;
      width: 648px;
      font-size: 64px;
      font-weight: 900;
      color: #000000;
      font-family: Poppins-Black, Poppins;
      line-height: 83px;
      margin: 0 auto;
      padding-bottom: 20px;
    }
    .SubTitle {
      font-size: 30px;
      font-weight: 500;
      color: #000000;
      font-family: Poppins-Medium, Poppins;
      line-height: 35px;
      padding-bottom: 20px;
    }
    .detail {
      width: 645px;
      font-size: 26px;
      font-weight: 500;
      font-family: Poppins-Medium, Poppins;
      color: #61666B;
      line-height: 43px;
      margin: 0 auto;
    }
  }
  .box-card {
    margin-top: 120px;
    text-align: center;
    .item {
      cursor: pointer;
      width: 650px;
      margin: 0 auto;
      img {
        width: 277px;
        height: 197px;
      }
      .introT{
        font-size: 32px;
        font-weight: 600;
        font-family: Poppins-SemiBold, Poppins;
        color: #1A1A2C;
        line-height: 54px;
        margin-top: 36px;
        margin-bottom: 30px;
      }
      .introD{
        font-size: 28px;
        font-weight: 500;
        font-family: PingFang SC-Medium, PingFang SC;
        color: #61666B;
        line-height: 46px;
        margin-bottom: 120px;
      }
      .tips{
        width: 650px;
        font-size: 24px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #4573E7;
        line-height: 41px;
      }
    }
  }
}
</style>
